import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  createLegalDoc,
  fetchLegalDocs,
  deleteLegalDoc,
} from '../redux/slices/legalDocsSlice';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../modalstyles/AddLegalDocsModal.css';

const ITEMS_PER_PAGE = 4;

const AddLegalDocsModal = ({ onClose }) => {
  const dispatch = useDispatch();
  const { list: docs, loading } = useSelector((state) => state.legalDocs);

  const [name, setName] = useState('');
  const [documentType, setDocumentType] = useState('');
  const [file, setFile] = useState(null);
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    dispatch(fetchLegalDocs());
  }, [dispatch]);

  const handleSubmit = async () => {
    if (!name || !documentType || !file) {
      toast.error('Please fill all required fields');
      return;
    }

    try {
      const result = await dispatch(
        createLegalDoc({ name, documentType, file })
      ).unwrap();

      toast.success('Document saved!');
      setName('');
      setDocumentType('');
      setFile(null);
      document.getElementById('doc-file-input').value = '';
      dispatch(fetchLegalDocs());
    } catch (err) {
      console.error('Submission error:', err);
      toast.error('Failed to upload document');
    }
  };

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this document?')) {
      dispatch(deleteLegalDoc(id)).then(() => dispatch(fetchLegalDocs()));
    }
  };

  const filteredDocs = docs.filter((doc) =>
    doc.name?.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filteredDocs.length / ITEMS_PER_PAGE);
  const paginatedDocs = filteredDocs.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <div className="AddLegalDocsModal-backdrop">
      <ToastContainer />
      <div className="AddLegalDocsModal-modal">
        <div className="AddLegalDocsModal-header">
          <h3>Add Legal Documents</h3>
          <button onClick={onClose} className="AddLegalDocsModal-closeBtn">
            &times;
          </button>
        </div>

        <div className="AddLegalDocsModal-body">
          <div className="AddLegalDocsModal-form">
            <label>Document Name</label>
            <input
              type="text"
              placeholder="Enter Document Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />

            <label>Document Type</label>
            <input
              type="text"
              placeholder="Enter Document Type"
              value={documentType}
              onChange={(e) => setDocumentType(e.target.value)}
            />

            <label>Document File</label>
            <input
              type="file"
              id="doc-file-input"
              accept=".pdf,.jpg,.jpeg,.png"
              onChange={(e) => setFile(e.target.files[0])}
            />

            <button
              onClick={handleSubmit}
              disabled={loading}
              className="AddLegalDocsModal-saveBtn"
            >
              {loading ? 'Saving...' : 'Save Document'}
            </button>
          </div>

          <div className="AddLegalDocsModal-table">
            <input
              type="text"
              placeholder="Search..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(1);
              }}
              className="AddLegalDocsModal-search"
            />
            <table>
              <thead>
                <tr>
                  <th>SN</th>
                  <th>Name</th>
                  <th>Type</th>
                  <th>File</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedDocs.map((doc, index) => {
                  const fileUrl = doc.documentFile?.startsWith('http')
                    ? doc.documentFile
                    : `http://213.210.37.235:3000/${doc.documentFile}`;

                  return (
                    <tr key={doc.id}>
                      <td>{(currentPage - 1) * ITEMS_PER_PAGE + index + 1}</td>
                      <td>{doc.name}</td>
                      <td>{doc.documentType}</td>
                      <td>
  {fileUrl.toLowerCase().endsWith('.pdf') ? (
    <a
      href={fileUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="AddLegalDocsModal-viewPdfBtn"
    >
      View PDF
    </a>
  ) : (
    <a href={fileUrl} target="_blank" rel="noopener noreferrer">
      <img
        src={fileUrl}
        alt="Document"
        className="AddLegalDocsModal-docImage"
      />
    </a>
  )}
</td>

                      <td>
                        <button
                          className="AddLegalDocsModal-deleteBtn"
                          onClick={() => handleDelete(doc.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })}
                {paginatedDocs.length === 0 && (
                  <tr>
                    <td colSpan="5">No documents found.</td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Pagination controls */}
            {totalPages > 1 && (
              <div className="AddLegalDocsModal-pagination">
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                  Prev
                </button>
                {[...Array(totalPages)].map((_, i) => (
                  <button
                    key={i + 1}
                    className={currentPage === i + 1 ? 'active' : ''}
                    onClick={() => handlePageChange(i + 1)}
                  >
                    {i + 1}
                  </button>
                ))}
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                  Next
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddLegalDocsModal;
